import type { AnchorHTMLAttributes } from 'react';
import Link from 'next/link';
import type { ReactMarkdownProps } from 'react-markdown/lib/complex-types';

// prevents from adding node="[object Object]" to the anchor tag
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function NextLink({ href, children, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement> & ReactMarkdownProps) {
  if (!href) {
    return <span {...rest}>{children}</span>;
  }

  if (href.startsWith('mailto:')) {
    return <span>{children}</span>;
  }

  if (href.includes('http')) {
    return (
      <a href={href} target="_blank" rel="noreferrer" {...rest}>
        {children}
      </a>
    );
  }

  // reverses simpleMarkdownTransform changes that turn underscores to em in links
  const hrefWithUnderscores = href.replaceAll(/<em>|<\/em>/g, '_');

  return (
    <Link href={hrefWithUnderscores} legacyBehavior passHref>
      <a {...rest}>{children}</a>
    </Link>
  );
}
